import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { renderRoutes } from 'react-router-config';
import { Router } from 'react-router-dom';
import { ReduxAsyncConnect } from 'redux-connect';
import { historySingleton } from 'src/client/history';
import { MobileDebugOverlay } from 'src/client/MobileDebugOverlay';
import { StoresProvider } from 'src/common/providers';
import { isProdEnv } from 'src/common/utils/environment';
import GlobalErrorBoundary from '../common/components/errors/GlobalErrorBoundary';
import reloadOnPropsChange from './utils/reloadOnPropsChange';

export default function Root({ onHistoryUpdate, store, stores, routes, localizations, locale }) {
  const props = {
    onHistoryUpdate,
    store,
    localizations,
    locale,
  };

  return (
    <Provider store={store}>
      <StoresProvider stores={stores}>
        {!isProdEnv() && <MobileDebugOverlay />}
        <GlobalErrorBoundary localizations={localizations}>
          <Router history={historySingleton.instance}>
            <ReduxAsyncConnect
              routes={routes}
              render={() => renderRoutes(routes, props)}
              reloadOnPropsChange={reloadOnPropsChange}
            />
          </Router>
        </GlobalErrorBoundary>
      </StoresProvider>
    </Provider>
  );
}

Root.propTypes = {
  onHistoryUpdate: PropTypes.func.isRequired,
  store: PropTypes.object.isRequired,
  stores: PropTypes.object.isRequired,
  routes: PropTypes.array.isRequired,
  numHotReloads: PropTypes.number.isRequired,
  localizations: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
};
